import React from "react";
import { Flex, Container, Text, Box } from "flicket-ui";
import { useRouter } from "next/router";
import useSWR from "swr";
import {
  Layout,
  Footer,
  BottomBar,
  Menu,
  Seo,
  ContentContainer,
  SlateRenderer,
} from "~components";
import { showToast, getError, sdk } from "~lib";
import { DesktopSubHeader } from "~components/common/common.BaseSubHeader";
import BaseHeader from "~components/common/common.BaseHeader";
import { useOrganization } from "~hooks";

const getMemberships = async (_: string, orgId: string, membershipId) =>
  sdk({ orgId }).membership({ id: membershipId });

const swrConfig = {
  shouldRetryOnError: false,
};

const TermsAndConditions = () => {
  const router = useRouter();
  const { organization, t } = useOrganization();
  const { data, error } = useSWR(
    organization?.id && router?.query?.membershipId
      ? ["memberships", organization?.id, router?.query?.membershipId]
      : null,
    getMemberships,
    swrConfig
  );

  if (error) {
    showToast(getError(error, "graphQL"), "error");
  }

  return (
    <>
      <Seo
        title={`${
          data?.membership?.name && data?.membership?.name + ": "
        }Terms and Conditions`}
        description={`${
          data?.membership?.name && data?.membership?.name + ": "
        }Terms and Conditions`}
      />
      <Menu />
      <Flex flexDirection="column" flex={1}>
        {/* Mobile */}
        <Box d={{ _: "block", md: "none" }} pb={8}>
          <BaseHeader
            title={data?.membership?.name}
            subTitle={"Terms and conditions"}
            onClickBack={() => {
              void router.push(`/memberships/${data?.membership?.id}`);
            }}
          />
        </Box>

        <Flex
          flexDirection="column"
          flex={1}
          maxH={{ _: "calc(100vh - 73px)", md: "unset" }}
          overflowY={{ _: "auto", md: "visible" }}
        >
          <Layout layoutType="overlay">
            <ContentContainer
              variant="content"
              image={data?.membership?.backgroundImage}
            >
              <Flex flexDir="column" pb={{ _: 2, md: 0 }} flex="1">
                <DesktopSubHeader
                  title={
                    <>
                      {data?.membership?.name && data?.membership?.name + ": "}
                      Terms and Conditions
                    </>
                  }
                  backToLinkText={`Back to ${t("membership_name")}`}
                  backToLink={`/memberships/${data?.membership?.id}`}
                  isSinglePage={false}
                />

                <Container
                  mb={{ _: 0, md: 10 }}
                  innerProps={{
                    minHeight: { _: 0, md: "320px" },
                  }}
                >
                  {data?.membership?.termsAndConditions ? (
                    <SlateRenderer
                      value={data?.membership?.termsAndConditions}
                    />
                  ) : (
                    <Text mb={{ _: 1, md: 2 }}>
                      Terms and Conditions coming soon!
                    </Text>
                  )}
                </Container>
              </Flex>
              <Footer />
            </ContentContainer>
          </Layout>
        </Flex>
      </Flex>
      <BottomBar />
    </>
  );
};

export default TermsAndConditions;
